import { Backdrop, Button, Checkbox, Chip, FormControlLabel, Grid, IconButton, Switch, Typography } from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import * as yup from "yup";
import CustomDataGrid from "../../../../../components/dataTable/customDataGrid";
import CustomTextField from "../../../../../components/utils/input/customTextField";
import Modal from "../../../../../components/utils/modal/modal";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import axios from "axios";
import { Delete, EditNote } from "@mui/icons-material";
import DeletePage from "../../../../../components/utils/deleteModal/deletePage";
import _ from "lodash";
import Loader from "../../../../../components/loader/loader";
import { Helmet } from "react-helmet-async";

const Uom = () => {
  const dispatch = useDispatch()
  const pageOption = [10, 25, 50, 100];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  // const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
  const [pageCount, setPageCount] = useState(0);
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);
  const [data, setData] = useState([])
  const [isEdit, setIsEdit] = useState(false)
  const [openDialog, setOpenDialog] = useState(false)
  const [activeId, setActiveId] = useState(null)
  const [active, setActive] = useState(false)
  const [isLoader, setIsLoader] = useState(false); //loader

  const validationSchema = yup.object({
    uom : yup.string().required(),
    uomSName: yup.string().required("UOM Short Name is required field")
  })
  
  const formik = useFormik({
    initialValues :{
      uom : "",
      uomSName:""
    },
    validationSchema:validationSchema,
    onSubmit: isEdit ? handleUpdate : handleCreate
  })
  const onCreate = () => {
    setOpen(true)
    formik.resetForm()
    setIsEdit(false)
  }
  function handleCreate(){
    const uomData = {
      units_short_name: formik.values.uomSName,
      units_long_name: formik.values.uom,
      company_id:1,
      is_active : active
    }
    setIsLoader(true);
    axios.post('/v1/units', uomData)
    .then(res=>{
      console.log(res)
      setOpen(false)
      getUomData()
      setIsLoader(false);
      dispatch(setSnackbar(true, 'success', 'Created Successfully'))
    })
    .catch(err=>{
      dispatch(setSnackbar(true, 'error',err.response.data.errors[0].message))
      console.log(err)
      setIsLoader(false);
    })
  }
  function onEdit(e){
    console.log(e)
    formik.setFieldValue('uom',e.name)
    formik.setFieldValue('uomSName',e.uomSName)
    setIsEdit(true)
    setOpen(true)
    setActive(e.isActive)
    setActiveId(e.id)
    }
    function handleUpdate(){
      const uomData = {
        units_short_name: formik.values.uomSName,
        units_long_name: formik.values.uom,
        company_id:1,
        is_active : active
      }
      setIsLoader(true);
      axios.put(`/v1/units/${activeId}`, uomData)
      .then(res=>{
        setOpen(false)
        console.log(res)
        getUomData()
        setIsLoader(false);
        dispatch(setSnackbar(true, 'success', 'Updated Successfully'))
      })
      .catch(err=>{
        dispatch(setSnackbar(true, 'error',err.response.data.errors[0].message))
        console.log(err)
        setIsLoader(false);
      })
    console.log('update')
    }
    function OnDelete(id){
      setOpenDialog(true)
      setActiveId(id)
    }  
    const handleDelete = () =>{
      setIsLoader(true);
      axios.delete(`/v1/units/${activeId}`)
      .then(res=>{
        setOpenDialog(false)
        getUomData()
        console.log(res)
        dispatch(setSnackbar(true, 'success', 'Deleted Successfully'))
        setIsLoader(false);
        setOpen(false)
      })
      .catch(err=>{
        dispatch(setSnackbar(true, 'error',err.response.data.errors[0].message))
        console.log(err)
        setIsLoader(false);
      })
    console.log('fasdf')
    }
  const columns = [
    {
      field: "sno",
      headerName: "S.no",
      flex: 1,
      minWidth: 70,
      maxWidth: 100,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "name",
      headerName: "Uom Name",
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "uomSName",
      headerName: "Uom Short Name",
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "active",
      headerName: "Status",
      flex: 1,
      disableExport: true ,
      headerAlign: "center",
      align: "center",
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <div className="">
        <Chip size='small' color={params.row.isActive ? 'success' : 'error'} label={params.row.isActive ? 'Active' : 'Inactive'}/>
        </div>
      )
    },
    {
      field: 'action',
      headerName: 'Action',
      flex: 1,
      disableExport: true ,
      minWidth: 100,
      headerAlign: "center",
      align: "center",
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <div className='flex justify-center w-full'>
          <IconButton onClick={()=>onEdit(params.row)} >
            <EditNote sx={{color:"#1972d2",fontSize:22}}/>
          </IconButton>
          <IconButton onClick={() => OnDelete(params.id)}>
            <Delete sx={{color:"red",fontSize:22}}/>
          </IconButton>
        </div>
      ),
    },
  ];
  const rows = _.map(data, (val,idx) => ({
    id:val.id,
    sno:++idx,
    name:val.units_long_name,
    uomSName:val.units_short_name,
    isActive:val.is_active

  }))
  const props = {
    rows: rows,
    columns: columns,
    search: search,
    setSearch: setSearch,
    page: page,
    setPage: setPage,
    rowsPerPage: rowsPerPage,
    setRowsPerPage: setRowsPerPage,
    pageCount: pageCount,
    pageOption: pageOption,
  };
  const getUomData = () =>{
    setIsLoader(true);
    const url = `/v1/units/${rowsPerPage}/${page + 1}`
    const searchUrl = `/v1/units/${rowsPerPage}/${page + 1}/${search}`
    axios.get(search === '' ? url : searchUrl)
    .then(res=>{
      setData(res.data.data)
      setPageCount(res.data.meta.pagination.total)
      setIsLoader(false);
    })
    .catch(err=>{
      console.log(err)
      setIsLoader(false);
      dispatch(setSnackbar(true, 'error', err.response.data.error))
    })
  }
  useEffect(()=>{
    getUomData()
    },[rowsPerPage, page, search])
    console.log(data)
  return (
    <Grid className="">
      <Helmet>
        <title>UOM</title>
      </Helmet>
      <Typography variant="h5">Unit of Measurements (UOM)</Typography>
      {!open &&
  <Grid className='flex justify-end'>
    <Button variant='contained' size='small' onClick={onCreate}>Create New</Button>
</Grid>}
 {open &&
        <Modal onClose={setOpen} formik={formik} onSave={formik.handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={4} lg={3}  >
            <CustomTextField id='uom' value={formik.values.uom} title='UOM' multiple={false} placeholder='Enter UOM' onchange={formik.handleChange} errorMsg={formik.touched.uom && Boolean(formik.errors.uom)} helperText={formik.touched.uom && formik.errors.uom}/>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}  >
            <CustomTextField id='uomSName' value={formik.values.uomSName} title='UOM Short Name' multiple={false} placeholder='Enter UOM Short Name' onchange={formik.handleChange} errorMsg={formik.touched.uomSName && Boolean(formik.errors.uomSName)} helperText={formik.touched.uomSName && formik.errors.uomSName}/>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} className="flex items-center">
            <FormControlLabel  control={<Checkbox checked={active} onChange={()=>setActive(!active)}/>} label="Active" />
            </Grid>
            
          </Grid>
        </Modal>
      } 
      <Grid className="bg-white rounded-md p-2 my-3">
        <CustomDataGrid props={props} />
      </Grid>
      <Backdrop open={openDialog} sx={{zIndex:1350}}>
  <DeletePage onCancel={setOpenDialog} onSubmit={handleDelete}/>
</Backdrop>
{/* <Loader isLoader={isLoader} /> */}
    </Grid>
  );
};

export default Uom;
